import { Component, Injectable, Input, OnInit, OnDestroy, ElementRef, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { AemService, CouponModel } from 'abs-ngx-library/src/lib/core';
import { CommonService, UserInfoService, CartService, UtilService, ProductCouponService, CartV2Service, ShopCouponRefresh } from 'abs-ngx-library/src/lib/core';
import { IConfigObj } from 'abs-ngx-library/src/lib/core';
import { isShellDrawerApp } from '../product-coupon.constants';


// jQuery
declare let $: any;


@Component({
    selector: 'product-coupon-al-v2',
    templateUrl: './product-coupon-al-v2.component.html',
})

@Injectable()
export class ProductCouponALV2Component implements OnInit, OnDestroy {

    @Input() product: any;
    @Input() productOffers: any;
    @Input() couponCalledBy: string;
    @Input() configObj?: IConfigObj;

    @Output() productCouponDetails: EventEmitter<any> = new EventEmitter<any>();

    public coupons: any[] = [];
    public availableOffersCounter = 0;
    public offersClippedCounter = 0;
    public singleCouponText: string;
    private _carouselTitle: any;
    private cartDetails: any;
    public isBOGO = false;
    public productDetails: any;

    // Boxtop modal variables
    public modalAttrName = 'modal';
    public modalIdName = '#boxtop-modal';
    public adaText = '';
    private isWYSIWYGEnabled = false;
    private _clipCouponSubscription: Subscription;

    // CMS BOGO texts
    public bogoText = '';

    // Multiple coupons texts
    public multipleClippedCouponsText = '';
    public couponsText= '<counter> deals available';

    @Input()
    set carouselTitle(carouselTitle: any) {
        this._carouselTitle = carouselTitle;
    }

    get carouselTitle(): any {
        return this._carouselTitle;
    }

    public constructor(
        public _commonService: CommonService,
        private _userInfoService: UserInfoService,
        private _elementRef: ElementRef,
        private cartService: CartService,
        private _utilService: UtilService,
        private _productCouponService: ProductCouponService,
        private cartV2Service: CartV2Service,
        private _aemService: AemService
    ) {

    }

    public ngOnInit() {
        this.productCouponInit();
    }

    private productCouponInit() {
        this.isBOGO = this.isBogoOffer();
        // get coupons from offers if is product carousel item in
        if (this.productOffers && typeof this.productOffers['offers'] !== 'undefined' && this.productOffers['offers'] != null) {
            for (const offer in this.productOffers.offers) {
                if (this.productOffers.offers.hasOwnProperty(offer) && !this.couponIsExpired(this.productOffers.offers[offer])) {
                    const offerObj = this.productOffers.offers[offer];
                    if (!(offerObj.hasOwnProperty('deliveryChannel') && offerObj.deliveryChannel === 'EC')) {
                        this.coupons.push(this.productOffers.offers[offer]);
                    }
                }
            }
        }

        this.productDetails = {
            'product': this.product,
            'offerCounter': this.availableOffersCounter,
            'offerClipped': this.offersClippedCounter,
            'coupons': this.coupons
        };
        this.productCouponDetails.emit(this.productDetails);

        this.processOfferByType();

        this._commonService.shopCouponRefreshSource.subscribe((couponRefresh: ShopCouponRefresh) => {
            if (couponRefresh && typeof couponRefresh === 'object' && 'id' in couponRefresh && 'deleted' in couponRefresh && 'status' in couponRefresh) {
                const coupon = this.coupons.find(coupon => coupon.offerId === couponRefresh.id);
                if (coupon) {
                    coupon.deleted = couponRefresh.deleted;
                    coupon.status = couponRefresh.status;
                    this.coupons = [...this.coupons];
                }
                const tempCoupons = JSON.parse(JSON.stringify(this.coupons));
                if (tempCoupons.length > 0) {
                    this.coupons = this.cartService.processOfferComplete(this.cartDetails, tempCoupons, this.product);
                }
                this.cartService.processBOGOComplete(this.cartDetails, this.product);
                this.processOfferByType();
                this.productDetails = {
                    'product': this.product,
                    'offerCounter': this.availableOffersCounter,
                    'offerClipped': this.offersClippedCounter,
                    'coupons': this.coupons
                };
                this.productCouponDetails.emit(this.productDetails);
            }
        });

        // check and update statuses when cart is updated
        this._commonService.currentCartObj.subscribe(objCart => {
            const singleCart =
                this.cartV2Service.fetchCartDetailsFromResponse(objCart, this.cartV2Service.getCartName(this.configObj.programType));
            this.cartDetails = singleCart;
            this.isWYSIWYGEnabled = this.cartDetails['isWYSIWYGEnabled'];
            const tempCoupons = JSON.parse(JSON.stringify(this.coupons));
            if (tempCoupons.length > 0) {
                this.coupons = this.cartService.processOfferComplete(this.cartDetails, tempCoupons, this.product);
            }
            this.cartService.processBOGOComplete(this.cartDetails, this.product);
            
        });

        /**
            * Subscribe to clipCouponSource event based on product upc to trriger clipCoupon method
            * Only for selected product not for all products instance
            * Check if the coupon is digital , unclipped and single coupon
        */
        this._clipCouponSubscription = this._productCouponService.clipDigitalCouponEvent$.pipe(
            filter(productUpc => (productUpc === this.product.upc) && this._isSingleUnClipDigitalCoupon()),
        ).subscribe(productUpc => {
            this.clipCoupon();
        });
    }

    private processOfferByType() {
        this.coupons = this.coupons.filter(coupon => coupon.isClippable || (!coupon.isClippable && coupon.ecomDescription));
        this.availableOffersCounter = (this.coupons) ? this.coupons.length : 0;

        // check number of offers clipped
        this.offersClippedCounter = (this.availableOffersCounter > 0) ? this._productCouponService.getOffersClipped(this.coupons) : 0;

        if (this.isBOGO) {
            this.availableOffersCounter = this.availableOffersCounter + 1;
            this.offersClippedCounter = this.offersClippedCounter + 1;
            this.setBogoText();
        }
        // set text for single coupon
        this.setSingleCouponText();

        // set text for clipped coupon
        this.setClippedCouponsText();

        // set text when all coupons are unclipped
        if (this.availableOffersCounter > 1) {
            this.couponsText = this.couponsText.replace('<counter>', this.availableOffersCounter.toString());
        }
    }
    // set text for bogo cms
    private setBogoText() {
        this.bogoText = this.product.promoDescription ? `${this.product.promoDescription}` : '';
    }

    private setSingleCouponText(){
        if (this.availableOffersCounter === 1 && this.coupons.length === 1) {
            this.singleCouponText = this.coupons[0].ecomDescription;
            this.coupons[0].offerComplete = this.coupons[0].offerComplete ? this.coupons[0].offerComplete : false;
        }
    }

    /**
     * Set the text for clipped coupons
     */
    private setClippedCouponsText() {
        this.multipleClippedCouponsText =`${this.offersClippedCounter} of ${this.availableOffersCounter} clipped`;
    }

    /**
     * @return true or false if the product is a BOGO offer
     */
    
    public isBogoOffer(): boolean {
        return (this.product.promoType === 'M' || this.product.promoType === 'B') && this.productPromoIsActive(this.product);
    }
   
    public couponIsExpired(coupon :any) {
        return this._productCouponService.isCouponExpired(coupon);
    }

    public productPromoIsActive(product :any) {
        return this._commonService.isProductPromoActive(product);
    }

    /**
     * Clip coupon when only one is available
     */
    public clipCoupon() {
        if (this.coupons[0]['offerSubPgm'] === '07' && (window['AB'].userInfo.boxTopAuth || !this._isRegistered())) {
            this.modalAttrName = '';
            this.modalIdName = '';
        }
        if (this._isRegistered()) {
            const storeId = window['AB']['userInfo']['branchId'];
            this._updateAnalyticsDataLayer();
            this._updateAnalyticsCarouselName();
            this._productCouponService.clipCoupon(this.coupons[0], storeId).subscribe(response => {
                if (response && response['items'] && response['items'][0] && response['items'][0]['status'] === 1) {
                    // Update the coupon status and deleted flag to reflect clipped state
                    this.coupons[0].status = 'C';
                    this.coupons[0].deleted = false;

                    this.offersClippedCounter = 1;
                    this._commonService.sendSponsoredProductClickEventForAllowedRoutes(this.product, 'productCoupon', 'clipCoupon');
                    this._commonService.shopCouponRefreshSource.next({
                        id: this.coupons[0]?.offerId,
                        status: 'C',
                        deleted: false
                    });
                    this.trackCRSClick('coupon-clip-click', response);

                    setTimeout(() => {
                        $('#clippedCoupon' + this.coupons[0].offerId).focus();
                        this.adaText = `${this.coupons[0].ecomDescription} coupon has been clipped.`;
                    }, 100);

                    setTimeout(() => {
                        this.adaText = '';
                    }, 500);
                    
                    const pageType = $('.product-info').attr('data-pagetype');
                    if (pageType === 'pdp') {
                      window.dispatchEvent(new CustomEvent('DigitalCouponClipped', { detail: { offerId: response["items"][0].itemId } }));
                    }
                }

            });
        } else {
            window['AB']['COMMON'].showSignInModal_OTP(window.location.href)
        }
    }
    /**
     *  Checking whether the coupon is digital and single coupon or not
    */
    private _isSingleUnClipDigitalCoupon(): boolean {
        if(this.availableOffersCounter === 1 && !this.isBOGO){
            return this.coupons[0]?.isClippable && (this.coupons[0]?.status === 'U'  || this.coupons[0]?.deleted === true);
        }
        return false;
    }

    /**
     * Analytics method for updating productInfo
     */
    private _updateAnalyticsDataLayer(): void {
        if (window['AB'] && window['AB']['DATALAYER']) {
            const analyticsCarouselTitle = this._carouselTitle ||
                window['AB']['DATALAYER'].getAnalyticsCarouselTitle(this._elementRef.nativeElement);
            window['AB']['DATALAYER'].productInfo({
                id: this.product.id,
                name: this.product.name,
                units: this.product.units,
                listPrice: this.product.price,
                basePrice: this.product.basePrice,
                carouselSection: analyticsCarouselTitle || '',
                pricingType: this.product.promoDescriptionVal || '',
                couponID: this.coupons.filter(offer => offer.status === 'C').map(offer => offer.offerId).toString(),
                couponFlag: this.availableOffersCounter,
                couponClipped: this.offersClippedCounter,
                aisleId: this.product.aisleId,
                upc: this.product.upc
            });
        }
    }

    /**
     * Analytics method for sending the offer info with the linkClick event
     * param offerType
     * param offerName
     */
    private _updateAnalyticsLinkClick(offerType :string, offerName :string): void {
        if (window['AB'] && window['AB']['DATALAYER']) {
            if (offerName) {
                window['AB']['DATALAYER'].setLinkClickOfferDrawer(offerType, offerName, this._elementRef.nativeElement);
            } else {
                let multipleText = '';
                if (this.offersClippedCounter === 0) {
                    multipleText = `${this.availableOffersCounter} Coupons Available`;
                    window['AB']['DATALAYER'].setLinkClickOfferDrawer(offerType, multipleText, this._elementRef.nativeElement);
                } else if (this.offersClippedCounter > 0) {
                    multipleText = `${this.offersClippedCounter} of ${this.availableOffersCounter} Coupons Clipped`;
                    window['AB']['DATALAYER'].setLinkClickOfferDrawer(offerType, multipleText, this._elementRef.nativeElement);
                }
            }
        }
    }

    private trackCRSClick(linkName: string, response?: any): void {
        const dataLayer = window['AB'] && window['AB']['DATALAYER'];
        if (!dataLayer || dataLayer.setCRSClickEvent === undefined || !dataLayer.isHomePage || !dataLayer.isHomePage()) {
            return;
        }

        const placement = localStorage.getItem('analyticsProductPlacement') || window['digitalData']?.pageFilter?.placement;
        const section = this._carouselTitle || dataLayer.getAnalyticsCarouselTitle?.(this._elementRef.nativeElement) || this.product?.carouselSection || 'no-val';
        const coupon = this.coupons?.[0] || {};
        const payload: any = {
            linkName,
            mTyp: 'product-carousel',
            element: this._elementRef.nativeElement,
            placement,
            component: dataLayer.getCRSComponent({
                element: this._elementRef.nativeElement,
                section,
                detail: this.product?.adobeMetrics?.metricA || this.product?.impressionAdditionalDetail || 'no-val',
                placement
            })
        };

        if (linkName === 'coupon-clip-click') {
            const clippedItem = response?.items?.[0] || {};
            payload.batchCouponsClipped = [{
                type: coupon?.offerPgm || coupon?.offerType || coupon?.offerProgramType || 'no-val',
                name: coupon?.brand || coupon?.name || coupon?.description || this.product?.name || 'no-val',
                id: String(coupon?.offerId || coupon?.couponID || clippedItem?.itemId || 'no-val'),
                clipMthd: 'singleclip',
                carouselSec: section,
                clipCnt: '1',
                clipID: clippedItem?.clipId || clippedItem?.clipID || response?.clipID || 'no-val',
                clipTime: new Date().toISOString(),
                divisionName: window['AB']?.userInfo?.divisionName || window['AB']?.userInfo?.division || 'no-val',
                msgData: coupon?.msgData || coupon?.messageData || coupon?.analyticsTag || 'no-val',
                savings: String(coupon?.savings || coupon?.savingsValue || '0')
            }];
        }

        dataLayer.setCRSClickEvent(payload);
    }

    private _updateAnalyticsModalViewSNS(name: string): void {
        if (window['AB'] && window['AB']['DATALAYER']) {
            window['AB']['DATALAYER'].setModalViewEvents(name);
        }
    }

    /**
     * Analytics method for updating the carousel name
     */
    private _updateAnalyticsCarouselName(): void {
        if (window['AB']['DATALAYER'] && this._carouselTitle) {
            window['AB']['DATALAYER'].setCarouselName('shop|' + this._carouselTitle);
        }
    }

    public setProductDetails(drawerType: string, coupon?: CouponModel): void {
        this._commonService.sendSponsoredProductClickEventForAllowedRoutes(this.product, 'productCoupon', 'couponClick');
        if (drawerType === 'offer-detail' || drawerType === 'coupon-list') {
            this.trackCRSClick('offer-details-click');
        }
        const isSNS = this.configObj.programType === '1P_SNS';
        const isOA = this.configObj.appName === '1P_OA';
        if (isSNS || isOA) {
            const eventName = isOA ? 'productCardComponentUpdate' : "snsOneTime";
            if (!eventName) return;
            //Check if snsOneTime programType is set and emit event else do default behavior
            switch (drawerType) {
                case 'offer-detail':
                    this._commonService.dispatchCustomOneTimeEvent(eventName, 'singleCoupon', { coupons: this.coupons[0] });
                    this._updateAnalyticsModalViewSNS('offer-details-j4u-productcards|view');
                    break;
                case 'coupon-list':
                    this._commonService.dispatchCustomOneTimeEvent(eventName, 'multipleCoupons', { product: this.product });
                    this._updateAnalyticsModalViewSNS('offer-details-multiple-productcards|view');
                    break;
            }
        } else {
            let objDrawerData = {};
            // reset name property to default value to properly display the tooltip.
            if (drawerType === 'coupon-list') {
                objDrawerData = {
                    type: drawerType,
                    couponList: this.coupons,
                    product: this.product
                };
                this._updateAnalyticsLinkClick('offer-drawer-multiple-productcards', null);
            } else if (drawerType === 'offer-detail') {
                objDrawerData = {
                    type: drawerType,
                    coupon: this.coupons[0],
                    product: this.product,
                    triggeredElement: 'single-coupon-product-card'
                };
                this._updateAnalyticsLinkClick('offer-drawer-j4u-productcards', this.singleCouponText);
            } else if (drawerType === 'bogo-detail') {
                objDrawerData = {
                    type: drawerType,
                    product: this.product,
                    triggeredElement: 'single-coupon-product-card'
                };
                this._updateAnalyticsLinkClick('offer-drawer-bogo-productcards', this.bogoText);
            }
            objDrawerData = { ...objDrawerData, configObj: this.configObj };
            if (isShellDrawerApp(this.configObj?.appName) && window['rightdrawerCompAlRef']) {
                window['rightdrawerCompAlRef'].zone.run(() => {
                    window['rightdrawerCompAlRef'].component.openRightDrawer(objDrawerData);
                });
            } else {
                this._commonService.rightDrawerSource.next(objDrawerData);
            }
        }
    }

    public getProductFullName() {
        let fullName = '';
        if (this.product) {
            fullName = this.product.fullName ? this.product.fullName : this.product.name;
        }
        return fullName;
    }

    /**
     * Method for checking if there is a single offer and is a BOGO
     * @return true or false if token is active and use is authorized
     */
    private _isRegistered(): boolean {
        return (this._utilService.isTokenActive() && this._userInfoService.isAuthorized());
    }

    /**
     * Method for checking if there is a single offer and is a coupon
     *
     * @return true or false based on the number of available offers
     */
    public isSingleOffer(): boolean {
        return (this.availableOffersCounter === 1 && !this.isBOGO);
    }

    /**
     * Method for checking if there is a single offer and is a BOGO
     *
     * @return true or false if the number of available offers is 1 and is a BOGO
     */
    public isSingleBogoOffer(): boolean {
        return this.availableOffersCounter === 1 && this.isBOGO && this.productPromoIsActive(this.product);
    }

    ngOnDestroy() {
        this._clipCouponSubscription?.unsubscribe();
    }


}
